module.exports = __webpack_public_path__ + "img/bucketplus_logo_top.e49b5138.svg";